import { PLATFORM } from "aurelia-framework";

export const MessageCentreDialogConstants = {
    AddPeopleToThisconversationDialog: PLATFORM.moduleName("@rightship-tech/message-centre-app/views/dialogs/add-people-to-this-conversation/dialog-add-people-to-this-conversation"),
    SendMessageDialog: PLATFORM.moduleName("@rightship-tech/message-centre-app/views/dialogs/send-message/dialog-send-message"),
    MarkAsCompleteDialog: PLATFORM.moduleName("@rightship-tech/message-centre-app/views/dialogs/mark-as-complete/dialog-mark-as-complete"),
    AddAttachmentToThisConversationDialog: PLATFORM.moduleName("@rightship-tech/common-ui/dialogs/dialog-attachments/dialog-attachments"),
}